import WEBAPI from '../../services/WEBAPI.js';
import * as ATypes from '../../shared/actionTypes';
import { getDerivedAuthority } from '../authoritySelection/utilities';

export const getHomeData = ({ num = 3, authority = null }) => {
  return async (dispatch, getState) => {
    const store = getState();

    const authorityName = authority || getDerivedAuthority(store);

    dispatch({
      type: ATypes.GET_HOME_DATA,
    });

    const homeResults = await WEBAPI.getHomeData(num, authorityName);
    const announcements = await WEBAPI.getMessages(authorityName, null, [
      'ANNOUNCEMENT',
    ]);
    const polls = await WEBAPI.getMessages(authorityName, null, ['POLL']);
    const events = await WEBAPI.getMessages(authorityName, null, ['EVENT']);

    const payload = {
      ...homeResults.result,
      announcements: announcements.result.data,
      polls: polls.result.data,
      events: events.result.data,
    };

    console.log('Home data fetched:', payload);

    await dispatch({
      type: ATypes.SET_HOME_DATA,
      payload: payload,
    });
  };
};

export const setCameFrom = (from) => {
  return {
    type: ATypes.SET_CAME_FROM,
    payload: from,
  };
};

export const searchAuthorityByLocation = (lat, lng) => {
  return (dispatch, getState) => {
    const store = getState();
    const authorityName = getDerivedAuthority(store);

    dispatch({
      type: ATypes.POST_AUTHORITY_PROMPT_OPTIONS_REQ,
    });

    return WEBAPI.searchAuthorityByLocation(lat, lng, authorityName).then(
      (res) => res.result
    );
  };
};

export const setUserDeclinedChangingAuthorityPrompt = (authorityRoute) => {
  return (dispatch) => {
    dispatch({
      type: ATypes.SET_USER_DECLINED_CHANGING_AUTHORITY,
      payload: authorityRoute,
    });
  };
};
